import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SessionConflictService {
  private showModal = new BehaviorSubject<boolean>(false);
  private conflictMessage = new BehaviorSubject<string>('');

  showModal$ = this.showModal.asObservable();
  conflictMessage$ = this.conflictMessage.asObservable();

  triggerConflict(message: string): void {
    this.conflictMessage.next(message);
    this.showModal.next(true);
  }

  dismiss(): void {
    this.showModal.next(false);
    this.conflictMessage.next('');
  }
}
